import assertNever from 'assert-never';

import { LicenseSystemCommunicationState } from '@shure/cloud/shared/models/devices';

import {
	LicenseSystemCommunicationStateV2 as SysApiLicenseSystemCommunicationStateV2,
	LicenseSystemCommunicationState as SysApiLicenseSystemCommunicationState
} from '../graphql/generated/cloud-sys-api';

export function mapLicenseSystemCommunicationState(
	state: SysApiLicenseSystemCommunicationState
): LicenseSystemCommunicationState {
	switch (state) {
		case SysApiLicenseSystemCommunicationState.Failure_4XxClientError:
		case SysApiLicenseSystemCommunicationState.Failure_5XxServerError:
		case SysApiLicenseSystemCommunicationState.FailureTimeout:
		case SysApiLicenseSystemCommunicationState.FailureUnknown:
			return LicenseSystemCommunicationState.Failed;
		case SysApiLicenseSystemCommunicationState.NotAttempted:
			return LicenseSystemCommunicationState.NotAttemped;
		case SysApiLicenseSystemCommunicationState.Success:
			return LicenseSystemCommunicationState.Success;
		default:
			assertNever(state);
	}
}

export function mapLicenseSystemCommunicationStateV2(
	state: SysApiLicenseSystemCommunicationStateV2
): LicenseSystemCommunicationState {
	switch (state) {
		case SysApiLicenseSystemCommunicationStateV2.Failure_4XxClientError:
		case SysApiLicenseSystemCommunicationStateV2.Failure_5XxServerError:
		case SysApiLicenseSystemCommunicationStateV2.FailureTimeout:
		case SysApiLicenseSystemCommunicationStateV2.FailureUnknown:
			return LicenseSystemCommunicationState.Failed;
		case SysApiLicenseSystemCommunicationStateV2.NotAttempted:
			return LicenseSystemCommunicationState.NotAttemped;
		case SysApiLicenseSystemCommunicationStateV2.Success:
			return LicenseSystemCommunicationState.Success;
		default:
			assertNever(state);
	}
}
